import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchSellerThreads, fetchBuyerThreads } from "../services/chatService";

const normalizeThread = (thread = {}) => ({
  roomId:
    thread.roomId ||
    thread.room_id ||
    (thread.product_id && thread.buyer_id && thread.seller_id
      ? `chat_${thread.product_id}_${thread.buyer_id}_${thread.seller_id}`
      : undefined),
  productId: thread.productId || thread.product_id,
  productName: thread.product_title || thread.product_name,
  buyerId: thread.buyerId || thread.buyer_id,
  buyerName: thread.buyerName || thread.buyer_name || thread.buyer,
  sellerId: thread.sellerId || thread.seller_id,
  sellerName: thread.sellerName || thread.seller_name || thread.seller,
  lastMessage: thread.lastMessage || thread.last_message,
  lastMessageAt: thread.lastMessageAt || thread.updated_at || thread.updatedAt,
  sendMessageAt: thread.send_message_at || thread.created_at,
  unreadCount: thread.unreadCount || thread.unread_count || 0,
  meta: thread.meta || {},
});



const useChatThreads = (input) => {
  const derivedUserId = typeof input === "string" ? input : input?.userId;
  const derivedRole =
    typeof input === "string" ? "seller" : input?.role?.toLowerCase() ?? "seller";

  const normalizedRole = derivedRole === "buyer" ? "buyer" : "seller";

  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadThreads = useCallback(async () => {
    if (!derivedUserId) return;
    setLoading(true);
    setError(null);
    try {
      const data =
        normalizedRole === "buyer"
          ? await fetchBuyerThreads(derivedUserId)
          : await fetchSellerThreads(derivedUserId);
      const normalized = Array.isArray(data)
        ? data.map(normalizeThread)
        : [];
      setThreads(normalized);
    } catch (err) {
      console.error("Chat threads error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [derivedUserId, normalizedRole]);

  useEffect(() => {
    loadThreads();
  }, [loadThreads]);

  const summary = useMemo(() => {
    const totalUnread = threads.reduce((acc, thread) => acc + (thread.unreadCount || 0), 0);
    return {
      totalThreads: threads.length,
      totalUnread,
    };
  }, [threads]);

  return {
    threads,
    loading,
    error,
    refresh: loadThreads,
    summary,
    role: normalizedRole,
  };
};

export default useChatThreads;

